import {
  FormFieldType,
  MeetingTypeFormField as LibraryFormField,
  MeetingType as LibraryMeetingType,
} from '@vendasta/meetings';
import { ValidatorFn } from '@angular/forms';
import { linkedInValidator, urlValidator } from './validators';

export type FormField = LibraryFormField & {
  validators?: ValidatorFn[];
};
export type SelectField = FormField & {
  type: FormFieldType.FORM_FIELD_TYPE_SELECT;
  config: { options: { text: string; value: string }[] };
};
export type MeetingTypeFormField = FormField | SelectField;

export interface MeetingTypeForm {
  fields: MeetingTypeFormField[];
}
export type MeetingType = Omit<LibraryMeetingType, 'form'> & {
  form: MeetingTypeForm;
};

export function getDaniMarioForm(): MeetingTypeForm {
  return {
    fields: [
      {
        id: 'companyName',
        type: FormFieldType.FORM_FIELD_TYPE_TEXT,
        label: 'Company Name',
        required: true,
        options: [],
      },
      {
        id: 'website',
        type: FormFieldType.FORM_FIELD_TYPE_TEXT,
        label: 'Please provide your website',
        required: false,
        validators: [urlValidator],
        options: [],
      },
      {
        id: 'linkedInUrl',
        type: FormFieldType.FORM_FIELD_TYPE_TEXT,
        label: 'Please provide your LinkedIn URL',
        required: false,
        validators: [linkedInValidator],
        options: [],
      },
      {
        id: 'numberOfEmployees',
        type: FormFieldType.FORM_FIELD_TYPE_SELECT,
        label: 'How many Employees do you have?',
        required: true,
        options: [],
        config: {
          options: [
            { text: '1-2', value: '1-2' },
            { text: '3-10', value: '3-10' },
            { text: '11-30', value: '11-30' },
            { text: '31-100', value: '31-100' },
            { text: '101+', value: '101+' },
          ],
        },
      },
    ],
  };
}
